import DashboardS from "metabase/css/dashboard.module.css";
import { Ellipsified, Text } from "metabase/ui";

interface ScalarPeriodProps {
  period: string | number | JSX.Element | null;
  onClick?: () => void;
}

// Keep period text on the same opaque token as comparison chrome. Text.css
// paints via `--text-color` from `color`; `c` alone is not enough.
const PERIOD_COLOR = "text-secondary-opaque";

export function ScalarPeriod({ period, onClick }: ScalarPeriodProps) {
  return (
    // maw="100%": this sits in a centered (cross-axis "center", not
    // "stretch") column flex, so it never gets a definite width to truncate
    // against — without a max-width cap, a long period string can overflow
    // the card's own boundary instead of ellipsizing under browser zoom
    // (WCAG 1.4.4).
    <Text
      data-testid="scalar-period"
      component="h3"
      ta="center"
      maw="100%"
      style={{ cursor: onClick && "pointer" }}
      c={PERIOD_COLOR}
      color={PERIOD_COLOR}
      fw={700}
      lh="1rem"
      className={DashboardS.fullscreenNormalText}
      onClick={onClick}
    >
      <Ellipsified
        c={PERIOD_COLOR}
        color={PERIOD_COLOR}
        className={DashboardS.fullscreenNormalText}
        tooltip={period}
        lines={1}
        tooltipProps={{ position: "bottom" }}
      >
        {period}
      </Ellipsified>
    </Text>
  );
}
